import { useIsShowingV4 } from 'hooks/useV4';

import V3Documentation from './v3Documentation';
import V4Documentation from './v4Documentation';

type Props = {
  isLoading?: boolean;
};

const Documentation = ({ isLoading }: Props) => {
  const isShowingV4 = useIsShowingV4();

  return isShowingV4 ? <V4Documentation isLoading={isLoading} /> : <V3Documentation isLoading={isLoading} />;
};

export default Documentation;
